exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/layout/header/search/search.component.scss
// module id = ../../../../../src/app/layout/header/search/search.component.scss
// module chunks = main